// extracted by mini-css-extract-plugin
module.exports = {"list":"checkbox-list_list__Jsos9","item":"checkbox-list_item__heJGO"};